
import Habitaciones from '@/components/Habitaciones/Habitaciones'
import Periodos from '@/components/Habitaciones/Periodos'
import Panel from '@/components/Habitaciones/Panel'

export default {
    path: '/habitaciones',
    name: 'habitaciones',
    component: Habitaciones,
    children: [
        {
            path: '',
            name: 'periodos',
            component: Periodos
        },
        {
            path: ':period_id/info',
            name: 'panel',
            component: Panel
        }
    ]
}



// WEBPACK FOOTER //
// ./src/router/monitorAndAdmin.js